import { ChevronLeft, Download, Loader2, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface RightSidebarHeaderProps {
  onBack?: () => void;
  onClickBtn?: () => void;
  title: string;
  subTitle: string;
  textBtn?: string;
  divider?: string;
  url?: string;
  fileName?: string;
  onDownload?: () => void;
  isDownloading?: boolean;
}

export const RightSidebarHeader = ({
  onBack,
  textBtn,
  onClickBtn,
  title,
  subTitle,
  divider = "|",
  url,
  fileName,
  onDownload,
  isDownloading,
}: RightSidebarHeaderProps) => {
  const handleDownload = async () => {
    if (!url) return;

    const response = await fetch(url, {
      method: "GET",
    });

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", fileName ?? "tic-sheet.pdf");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  };

  return (
    <div className="sticky top-0 flex w-full cursor-pointer items-center justify-between border-b border-border bg-background px-4 py-[18px]">
      <div className="flex w-full items-center justify-between">
        <div className="flex w-full min-w-0 items-center gap-2">
          {onBack && (
            <Button variant="ghost" size="icon" className="h-6 w-6 shrink-0" onClick={onBack}>
              <ChevronLeft className="h-4 w-4 text-muted-foreground" />
            </Button>
          )}
          <p className="min-w-0 truncate text-xs font-medium text-muted-foreground">
            {title}
            {divider && <span className="px-1 text-muted-foreground/70"> {divider} </span>}
            {subTitle && <span> {subTitle}</span>}
          </p>
        </div>

        {(url || onDownload) && (
          <div>
            {isDownloading ? (
              <Loader2 className="h-5 w-5 animate-spin text-gray-600" />
            ) : (
              <Download
                onClick={url ? handleDownload : onDownload}
                className="h-5 w-5 cursor-pointer text-gray-600 transition-colors hover:text-black"
              />
            )}
          </div>
        )}
      </div>

      {textBtn && (
        <Button variant="secondary" size="sm" onClick={onClickBtn}>
          <Plus className="h-4 w-4" />
          {textBtn}
        </Button>
      )}
    </div>
  );
};
